<template>
  <ValidationObserver ref="address_form">
    <ValidationProvider name="código postal" rules="max:15" v-slot="{ errors }">
      <v-text-field
        :label="__('CEP')"
        v-model="postal_code"
        :error-messages="errors"
        outlined
        dense
        :color="themeColor"
      />
    </ValidationProvider>

    <ValidationProvider
      name="address.district"
      rules="required"
      v-slot="{ errors }"
    >
      <select-country-area
        v-model="country_area"
        :label="__('Estado')"
        :error-messages="errors"
        clearable
        :color="themeColor"
        outlined
        dense
        public-api
      />
    </ValidationProvider>

    <ValidationProvider
      name="address.country"
      rules="required"
      v-slot="{ errors }"
    >
      <select-city
        v-model="city"
        :country_area="country_area"
        :label="__('Cidade')"
        :error-messages="errors"
        clearable
        :color="themeColor"
        outlined
        dense
        public-api
      />
    </ValidationProvider>

    <ValidationProvider name="address.neighborhood" v-slot="{ errors }">
      <select-city-area
        v-model="city_area"
        :city="city"
        :label="__('Bairro')"
        :error-messages="errors"
        clearable
        return-object
        :color="themeColor"
        outlined
        dense
        public-api
      />
    </ValidationProvider>

    <ValidationProvider
      name="address.street"
      rules="required|max:100"
      v-slot="{ errors }"
    >
      <v-combobox
        v-model="form.street"
        :items="streets"
        :label="__('Rua')"
        :error-messages="errors"
        :color="themeColor"
        outlined
        dense
      />
    </ValidationProvider>

    <ValidationProvider
      name="address.number"
      rules="max:45"
      v-slot="{ errors }"
    >
      <v-text-field
        :label="__('Número')"
        v-model="form.number"
        :error-messages="errors"
        :color="themeColor"
        outlined
        dense
      />
    </ValidationProvider>
    <!-- <v-btn color="red" dark class="mt-4" :loading="loading" @click="handleSave">
      Salvar morada
    </v-btn> -->
  </ValidationObserver>
</template>

<script>
import SelectCountryArea from "../locals/SelectCountryArea";
import SelectCity from "../locals/SelectCity";
import SelectCityArea from "../locals/SelectCityArea";
import { autocompleteZipCode } from "@/services/customer_inbound";
import i18n from "@/mixins/i18n";

export default {
  name: "AddressFormStep",
  components: { SelectCountryArea, SelectCity, SelectCityArea },
  mixins: [i18n],
  props: {
    init: Object,
    color: {
      type: String,
    },
    themeColor: {
      type: String,
      default: "red",
    },
  },

  data() {
    return {
      i18n_prefix: "address",
      form: {
        street: "",
        number: "",
      },
      postal_code: "",
      country_area: null,
      city: null,
      city_area: null,
      streets: [],
      loading: false,
    };
  },

  methods: {
    async validate() {
      return this.$refs.address_form.validate();
    },

    getValue() {
      return {
        ...this.form,
        postal_code: this.postal_code,
        country_area: this.country_area,
        city: this.city,
        city_area: this.city_area,
      };
    },

    async getPostalAddresses(postal_code) {
      if (!postal_code) return;

      this.loading = true;
      try {
        const address = await autocompleteZipCode("pt", postal_code);

        this.country_area = address.country_area
          ? {
              id: address.country_area.country_area_id,
              name: address.country_area.country_area,
            }
          : null;

        this.city = address.city || null;
        this.city_area = address.city_area
          ? {
              id: address.city_area.city_area_id,
              name: address.city_area.city_area,
            }
          : null;

        this.streets = address.streets || [];
      } finally {
        this.loading = false;
      }
    },

    // async handleSave() {
    //   const valid = await this.validate();
    //   if (!valid) return;

    //   this.$emit("save", this.getValue());
    // },
  },

  created() {
    if (this.init) {
      this.form = { ...this.init };
      this.postal_code = this.init.postal_code;
      this.country_area = this.init.country_area;
      this.city = this.init.city;
      this.city_area = this.init.city_area;
    }
  },

  watch: {
    postal_code(value) {
      if (!value || value.length < 7) return;

      this.getPostalAddresses(value);
    },
  },
};
</script>
